export enum ArrowStyle {
    SOLID="SOLID",
    DASHED="DASHED",
    DOTTED="DOTTED",
};

export enum ArrowType {
    SQUARED="SQUARED",
    L_SHAPED="L_SHAPED",
    DIRECT="DIRECT",
};
